import React, { useState, useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { Link, useLocation } from 'react-router-dom';
import './header.scss';
import BurgerMenu from './BurgerMenu/burgerMenu';

import { authState } from '../../state/auth.state';
// import LogoutButton from '../buttons/logout.button';
// import { USER_STATUS } from '../../constants';
import AppIcons from '../../assets/images/icons';



export default function AppHeader() {

    const location = useLocation();
    const [currentURL, setCurrentURL] = useState('');
    const auth = useAtomValue(authState)
    useEffect(() => {
        setCurrentURL(location.pathname); // to set the current url
    }, [location.pathname]);


    return (
        <div className='main-header-wrp f-wrp'>
            <div className='header-container'>
                <div className='header-con-box f-wrp'>
                    <BurgerMenu />
                    {currentURL === '/' ? <> <div className='ryt-head-con'>
                        {auth.isLoggedIn ? <span className='prof-box'><img src={AppIcons.sampleIcon} alt={`${auth.firstName} ${auth.lastName}`} /> {`${auth.firstName ?? ''} ${auth.lastName ?? ''}`}</span> : null}
                        {/* {auth.isLoggedIn ? <LogoutButton /> : <Link to={'/auth/login'} className='sqr-btn'>Login</Link>} */}
                    </div>
                    </> : null}
                </div>
            </div>
        </div>
    )

}